import React, { useEffect } from 'react'
import { ApiPostCallAuthKey } from '../JS/Connector';
import { getUrlParameter } from '../JS/Common';
import { log } from '../JS/Logger';
function PaymentSuccessPage() {
    const session_id = getUrlParameter("session_id");
    const TRUSTED_RECEIPT_ORIGINS = ['https://dashboard.stripe.com', 'https://pay.stripe.com', 'https://checkout.stripe.com'];

    useEffect(() => {
        var raw = JSON.stringify({
            sessionId: session_id,
        });
        ApiPostCallAuthKey("/plans/insurance/checkout-details", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const ResponseRs = JSON.parse(result)
                if (ResponseRs.status == "success") {
                    try {
                        const parsed = new URL(ResponseRs.receipt_url);
                        if (TRUSTED_RECEIPT_ORIGINS.some(o => parsed.origin === o)) {
                            window.location.href = ResponseRs.receipt_url;
                        } else {
                            alert(`Untrusted redirect blocked: ${ResponseRs?.receipt_url}`);
                        }
                    } catch (err) { log.error(err) }
                    // window.location.href = ResponseRs.receipt_url;
                }
            }
        });
    }, [session_id]);

    return (
        <>
        </>
    )
}
export default PaymentSuccessPage
